import clsx from 'clsx';

export const header = clsx(
  'fixed',
  'top-0',
  'left-0',
  'w-full',
  'z-50',
  'transition-all',
  'duration-300',
  'shadow-sm'
);

export const headerScrolled = clsx('bg-title', 'opacity-90', 'shadow-title');
export const headerNotScrolled = clsx(
  'bg-background',
  'shadow-md',
  'backdrop-blur',
  'shadow-background'
);

export const container = clsx(
  'flex',
  'justify-between',
  'items-center',
  'max-w-[100%]',
  'md:max-w-[80%]',
  'mx-auto',
  'px-6',
  'py-4'
);

export const logo = (scrolled) =>
  clsx('text-xl', 'font-bold', scrolled ? 'text-background' : 'text-title');

export const logoImage = clsx(
  'max-w-[90%]',
  'md:max-w-64',
  'object-contain',
  'self-center',
  'justify-center'
);

export const nav = (scrolled) =>
  clsx(
    'hidden',
    'md:flex',
    'gap-8',
    'font-medium',
    scrolled ? 'text-background' : 'text-title'
  );

export const navLink = clsx(
  'hover:opacity-80',
  'transition-colors',
  'description',
  'cursor-pointer',
);

export const buttonsContainer = clsx('flex', 'gap-3', 'items-center');

export const whatsappButton = clsx(
  'flex',
  'items-center',
  'gap-1',
  'md:gap-2',
  'text-background',
  'text-[9px]',
  'md:text-sm',
  'px-4',
  'py-2',
  'rounded-full',
  'shadow',
  'description',
  'transition-colors',
  'bg-green-500',
  'hover:opacity-90',
  'justify-center'
);

export const instagramButton = clsx(
  'flex',
  'items-center',
  'gap-1',
  'md:gap-2',
  'text-[9px]',
  'md:text-sm',
  'description',
  'px-4',
  'py-2',
  'rounded-full',
  'shadow',
  'transition-colors',
  'hover:opacity-90',
  'justify-center'
);

export const instagramButtonScrolled = clsx(
  'bg-background',
  'text-title'
);

export const instagramButtonNotScrolled = clsx(
  'bg-title',
  'text-background'
);
